export default {
    /**
     * Form meta*/
    form: {
        fields: [],
        formconf: {}
    },
    error: null,
    errors: {},
    showAllFields: false
};
